import PortraitEji from "../../assets/images/png/podcast/enyinnaya-ijoma-v2Podcast.png";
import PortraitEyitayo from "../../assets/images/png/podcast/eyitayo-ogunmola-v2Podcast.png";
import PortraitOlamide from "../../assets/images/png/podcast/olamide-abdul-v2Podcast.png";
import PortraitOnyinye from "../../assets/images/png/podcast/onyinye-mystash-v2Podcast.png";

export const podcastData = [
  {
    id: 1,
    epNumber: "EP 01",
    image: PortraitEyitayo,
    category: "Leadership & Building",
    title: "Building talent, opportunity and a technology learning company",
    description:
      "A founder conversation about building, learning and creating more practical routes into technology careers.",
    name: "Eyitayo Ogunmola",
    role: "Founder, Utiva",
    featured: true,
    linkUrl: "https://open.spotify.com/episode/0z7MleCXvfcq3WnN6MwhaV",
  },
  {
    id: 2,
    epNumber: "EP 02",
    image: PortraitOlamide,
    category: "Career Growth",
    title: "The choices and lessons behind a growing technology career",
    description:
      "A grounded conversation about professional growth, career decisions and learning from experience.",
    name: "Olamide Abdul",
    role: "Guest speaker",
    featured: false,
    linkUrl: "https://open.spotify.com/episode/1E0ZFYvM1XZrWqeOmK5Nlv",
  },
  {
    id: 3,
    epNumber: "EP 03",
    image: PortraitEji,
    category: "Technology Careers",
    title: "Finding direction and building credibility in technology",
    description:
      "An honest discussion about navigating the industry, building skills and earning trust along the way.",
    name: "Enyinnaya Ijoma",
    role: "Guest speaker",
    featured: false,
    linkUrl: "https://open.spotify.com/episode/56ndSwVbNzKyf22KjK5Xbx",
  },
  {
    id: 4,
    epNumber: "EP 04",
    image: PortraitOnyinye,
    category: "Founders & Fintech",
    title: "Building products that help people make better money decisions",
    description:
      "A founder-focused conversation on fintech, financial literacy and product thinking.",
    name: "Onyinye Oguego",
    role: "Founder, myStash",
    featured: false,
    linkUrl: "https://open.spotify.com/episode/4XzwsUafJ8733Zw26AnrzG",
  },
];
